export const cariIslemTurTypes = {
  TAHSILAT: "Tahsilat",
  ODEME: "Odeme",
  ALACAK: "Alacak",
  BORC: "Borc",
};
